import { FgaUserState } from '@/generated/model';

import type { UserAccessState } from '../types/UserAccessState';

const stateLabelTranslationKeys: Record<UserAccessState, string> = {
  [FgaUserState.ACTIVE]: 'userAccessControl.states.active',
  [FgaUserState.DEACTIVATED]: 'userAccessControl.states.deactivated',
  [FgaUserState.WAITING_FOR_ACTIVATION]: 'userAccessControl.states.waitingForActivation',
};

const stateDescriptionTranslationKeys: Record<UserAccessState, string> = {
  [FgaUserState.ACTIVE]: 'userAccessControl.details.activeDescription',
  [FgaUserState.DEACTIVATED]: 'userAccessControl.details.deactivatedDescription',
  [FgaUserState.WAITING_FOR_ACTIVATION]: 'userAccessControl.details.expiredInvitationDescription',
};

export function getStateLabelKey(state: UserAccessState) {
  return stateLabelTranslationKeys[state];
}

export function getStateDescriptionKey(state: UserAccessState) {
  return stateDescriptionTranslationKeys[state];
}
